export default "__VITE_ASSET__BSKwoERX__"